import Vue from 'vue';
import Vuex from 'vuex';
import settings from '../settings';
import { app } from './modules/app';

Vue.use(Vuex);

const debug = !settings.isProd;

const store = new Vuex.Store({
  modules: { app },
  strict: debug,
  plugins: [],
});
export default store;
